var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcelActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.0002 9.5H44.3331C40.8592 9.5 37.9995 12.3597 37.9995 15.8329V42.75L95.0002 76L123.5 88.0253L152 76V42.75L95.0002 9.5Z",
    fill: "#21A366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9995 42.75H95.0002V76H37.9995V42.75Z",
    fill: "#107C41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.667 9.5H95V42.75H152V15.8329C152 12.3597 149.14 9.5 145.667 9.5Z",
    fill: "#33C481"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0002 76H37.9995V136.167C37.9995 139.64 40.8592 142.5 44.3331 142.5H145.667C149.141 142.5 152 139.64 152 136.167V109.25L95.0002 76Z",
    fill: "#185C37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95 76H152V109.25H95V76Z",
    fill: "#107C41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1671 33.25H38V123.5H79.1671C82.6369 123.49 85.4903 120.637 85.5 117.167V39.5829C85.4903 36.1131 82.6369 33.2597 79.1671 33.25Z",
    fill: "black",
    fillOpacity: 0.094118
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4171 38H38V128.25H74.4171C77.8869 128.24 80.7403 125.387 80.75 121.917V44.3329C80.7403 40.8631 77.8869 38.0097 74.4171 38Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4171 38H38V118.75H74.4171C77.8869 118.74 80.7403 115.887 80.75 112.417V44.3329C80.7403 40.8631 77.8869 38.0097 74.4171 38Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6671 38H38V118.75H69.6671C73.1369 118.74 75.9903 115.887 76 112.417V44.3329C75.9903 40.8631 73.1369 38.0097 69.6671 38Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33287 38H69.6671C73.1403 38 76 40.8597 76 44.3329V107.667C76 111.14 73.141 114 69.6671 114H6.33287C2.85967 114 0 111.14 0 107.667V44.3329C0 40.8597 2.85967 38 6.33287 38Z",
    fill: "#107C41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7837 99.75L32.1536 75.9337L18.0757 52.25H29.4045L37.0895 67.3871C37.7956 68.8235 38.2813 69.8951 38.5466 70.6012H38.6461C39.1532 69.4536 39.6839 68.3378 40.2366 67.2552L48.4508 52.25H58.8525L44.4097 75.801L59.2166 99.75H48.1523L39.2749 83.1219C38.8569 82.4151 38.5024 81.6717 38.215 80.9027H38.083C37.8232 81.6565 37.4792 82.3785 37.0556 83.0549L27.9135 99.75H16.7837Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelActive);
export default __webpack_public_path__ + "static/media/excel-active.b83204526aea09a6a5c01135fa3642cb.svg";
export { ForwardRef as ReactComponent };